/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ICategoryPageContainerViewProps } from './category-page-container';
import {ILinkData} from "../img-block";

const _renderTitle=(title: string, mainHeaderCustomClass: string): JSX.Element => {
    let mainHeaderLeft = mainHeaderCustomClass + " left"
    let mainHeaderRight = mainHeaderCustomClass + " right"
    if(title == undefined){
        return(
            <div className="no-title">
            </div>
            )
    } else {
        return(
            <div className="container category-header-container">
                <div className={mainHeaderLeft}></div>
                <h1 className="category-header">{title}</h1>
                <div className={mainHeaderRight}></div>
            </div>
            )
    }
   };

const _renderSlogan=(slogan: string, sloganCustomClass: string, links: ILinkData[] | undefined): JSX.Element => {
    let pageLink;
    if(links == undefined || links.length < 1){
        return (
                <div>
                    <h3 className={sloganCustomClass}>{slogan}</h3>
                </div>
        );
    } else {
        pageLink = links[0].linkUrl.destinationUrl;
        return (
            <a href={pageLink} className="category-a-tag2">
                    <h3 className={sloganCustomClass}>{slogan}</h3>
            </a>
        );
    }
};

const _renderAllLink = (displayAllLink: boolean | undefined, links: ILinkData[] | undefined): JSX.Element | undefined => {
    if (!displayAllLink || !links?.length) {
        return undefined;
    }
    return (
        <div className={'row justify-content-end'}>
            <a href={links[0].linkUrl.destinationUrl}>{links[0].linkText}</a>
        </div>
    )
}

export default (props: ICategoryPageContainerViewProps) => {
    const { slots, title, slogan, mainHeaderCustomClass, pageBorderCustomClass, contentCustomClass, sloganCustomClass, config: { displayAllLink , links } } = props;
    let contentClass = "row " + contentCustomClass

    return (
        <div  className={pageBorderCustomClass} {...props.renderModuleAttributes(props)} id={props.id}>
            {_renderTitle(title, mainHeaderCustomClass)}
            <div className="container category-page-container">
                <div className={contentClass}>
                    {slots.slot1}
                </div>
                {_renderAllLink(displayAllLink , links)}
            </div>
            {_renderSlogan(slogan, sloganCustomClass, links)}
        </div>
    );
}
